import axios from "../axiosPlugin.js";

export const regenCloseService = data => {
  return axios({
    url: "/api/report/regenShiftCloseAndDayClose",
    method: "get",
    data: {
      data
    },
  });
};